import { OrderedMap, Map } from 'immutable';

export const getLocalResponses = () => {
  const keys = Object.keys(global.localStorage);

  let responses = new OrderedMap();

  keys.forEach((key) => {
    if (key.startsWith('examQuestionResponse-')) {
      const item = JSON.parse(localStorage.getItem(key));

      responses = responses.set(`${item.question}`, Map(item));
    }
  });

  return responses;
};
